import Mutations from '../../odata/mutations';

export default { ...new Mutations('contractSectionLineItem'), ...new Mutations('contractSectionLineItems') };
